import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance, loginRequest } from '../configs/authConfig';

// Redirects are blocked inside an iframe, so the widget logs in with a popup instead.
const isInIframe = () => window.self !== window.top;

// Call only from a user action, otherwise the browser blocks the popup.
export const login = () => {
    const action = isInIframe() ? msalInstance.loginPopup(loginRequest) : msalInstance.loginRedirect(loginRequest);
    return action.catch(console.error);
};

export const logout = () => msalInstance.logoutRedirect().catch(console.error);

export const getToken = async () => {
    const accounts = msalInstance.getAllAccounts();
    const request = {
        ...loginRequest,
        account: accounts[0],
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (e) {
        // Without an account the silent call cannot succeed either, so fall back to interaction.
        if (!(e instanceof InteractionRequiredAuthError) && accounts.length > 0) {
            throw new Error(`Auth fail: ${e}`);
        }

        if (isInIframe()) {
            const response = await msalInstance.acquireTokenPopup(request);
            return response.accessToken;
        }

        await msalInstance.loginRedirect(request);
        throw new Error('Redirecting to login');
    }
};
